import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import EmptyState from "@/components/EmptyState";
import { useMeta } from "@/lib/useMeta";

export default function NotFound() {
  useMeta({ title: "পেজটা পাওয়া যায়নি — মুমতাহিন গ্যালারি" });
  return (
    <div className="container py-16">
      <EmptyState
        icon={Compass}
        title="এই ঠিকানায় কোনো পেজ নেই"
        actions={
          <>
            <Button asChild>
              <Link to="/papers">প্রশ্নপত্র খুঁজুন</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/">হোমে যান</Link>
            </Button>
          </>
        }
      >
        লিংকটা ভুল হতে পারে, অথবা পেজটা সরিয়ে ফেলা হয়েছে।
      </EmptyState>
    </div>
  );
}
